/**
 * Copilot 外观配置（build / dev 启动前在 .env 中设置）
 *
 * REACT_APP_COPILOT_AVATAR=/copilot-avatar.png   ← 图片放 public/ 目录
 * REACT_APP_COPILOT_NAME=小Ox
 * REACT_APP_COPILOT_TITLE=决策助手
 */

const DEFAULT_AVATAR = '/decision-copilot-avatar.svg';

export const copilotConfig = {
  avatarUrl: process.env.REACT_APP_COPILOT_AVATAR || DEFAULT_AVATAR,
  name: process.env.REACT_APP_COPILOT_NAME || 'Copilot',
  title: process.env.REACT_APP_COPILOT_TITLE || '决策 Copilot'
};
